var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTeacherStudent = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  x: 0,
  y: 0,
  viewBox: "0 0 24 24",
  style: {
    enableBackground: "new 0 0 24 24"
  },
  xmlSpace: "preserve"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 6.9,
  r: 6.9
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M16.5 14.8h-.6c-1.2.5-2.5.9-3.9.9s-2.7-.3-3.9-.9h-.6c-3.9 0-7.2 3-7.5 6.9 0 .4.3.6.6.8 1 .6 6.5 1.5 11.4 1.5s9.9-.9 11.4-1.6c.3-.1.6-.4.6-.8-.3-3.8-3.5-6.8-7.5-6.8z"
})));
export default SvgTeacherStudent;